import { UseFormReturn } from 'react-hook-form'
import useJobFilters from '@hooks/useJobFilters'
import { FiltersProps } from '@templates/ListPageLayout/Filters'
import { FilterTypes } from '@templates/ListPageLayout/Filters/Filter'

const useDivisionFilters = (methods: UseFormReturn): FiltersProps => {
  const { company, filial } = useJobFilters(methods)

  const filters: FiltersProps = [
    {
      filterType: FilterTypes.HIDDEN,
      fieldName: 'id',
    },
  ]

  if (company) {
    filters.push({
      ...company,
      fieldNameForSubmit: 'companyBranch.company',
    })
  }

  if (filial) {
    filters.push({
      ...filial,
      fieldNameForSubmit: 'companyBranch',
    })
  }

  return filters
}

export default useDivisionFilters
